import React from 'react'
import { connect } from 'react-redux'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'
import DateTime from 'react-datetime'
import TransferHistoryActions from '../../Redux/TransferHistoryRedux'

class DownloadAutoTransferList extends React.Component {
  constructor (props) {
    super (props)
    this.processStatus = [
      {value: 'auto-confirm', label: 'AUTO CONFIRM'},
      {value: 'manual-confirm', label: 'MANUAL CONFIRM'},
      {value: 'manual-match', label: 'MANUAL MATCH'}
    ]
    this.state = {
      filter: {
        from: null,
        until: null,
        status: ''
      }
    }
  }

  _filterChange = (data, field) => {
    const uniq = ['page', 'filterDate', 'from', 'until']
    let val = null
    if (includes(uniq, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(data)) {
          val = data
        }
      } else {
        val = data
      }
    } else {
      val = data.target.value
    }
    let filter = {...this.state.filter}
    filter[field] = val
    this.setState({ filter })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = {
      ...this.state.filter
    }

    if (this.state.filter.from && this.state.filter.until) {
      data.from = this.state.filter.from.format('Y-MM-DD')
      data.until = this.state.filter.until.format('Y-MM-DD')
    } else {
      data.from = null
      data.until = null
    }

    this.props.download(data)
    this.props.closeModal()
  }

  render() {
    const { transfer_history } = this.props
    const { from } = this.state.filter
    let yesterday = from
    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '20vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Download Transfer History
            {(transfer_history.fetching || transfer_history.processing) && 
              <div className="badge badge-info ml-2">{transfer_history.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>
        <div className="form-group">
          <label className="control-label mr-2">Date From</label>
          <DateTime
            value={this.state.filter.from}
            closeOnSelect={true}
            onChange={(date) => this._filterChange(date, 'from')}
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
          />
        </div>
        <div className="form-group">
          <label className="control-label mr-2">Date To</label>
          <DateTime
            value={this.state.filter.until}
            closeOnSelect={true}
            onChange={(date) => this._filterChange(date, 'until')}
            dateFormat="DD/MM/YYYY"
            timeFormat={false}
            isValidDate={ (current) => current.isAfter( yesterday ) }
          />
        </div>
        <div className="form-group">
          <label className="control-label mr-2">Process Status</label>
          <select className="form-control" value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
            <option value="">-Select Process-</option>
            {this.processStatus.map((item, i) => (
              <option key={i} value={item.value}>{item.label}</option>
            ))}
          </select>
        </div>
        <div className="text-right">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" className="btn btn-lg btn-primary">Download</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  transfer_history: state.transfer_history
})

const dispatchToProps = (dispatch) => ({
  download: (filter) => dispatch(TransferHistoryActions.transferHistoryListDownloadRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(DownloadAutoTransferList)



// WEBPACK FOOTER //
// ./src/Containers/Order/DownloadAutoTransferList.js